import { FC } from 'react'

import { Controller, useForm, useWatch } from 'react-hook-form'
import { Radio } from 'antd'
import styled from 'styled-components'
import { yupResolver } from '@hookform/resolvers/yup'

import { variables } from 'src/Styled/variables'
import { PrimaryRadio } from 'src/Components/PrimaryRadio'
import { PrimaryTextArea } from 'src/Components/PrimaryTextArea'
import { MAX_COMMENT_LENGTH } from 'src/Constants/numeric'

import { CancelButtons } from '../CancelButtons'

import { CANCEL_PREMIUM_REASONS, cancelPremiumFormSchema } from './schema'

const StyledRadio = styled(PrimaryRadio)`
  font-size: ${variables.fontSize14};
`

const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`
const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 19px;
`

export interface CancelPremiumFormValues {
  reason: string
  reasonDetails?: string
}

interface CancelPremiumFormProps {
  onSave: (data: CancelPremiumFormValues) => void
  loading?: boolean
}
export const CancelSubscriptionForm: FC<CancelPremiumFormProps> = ({
  onSave,
  loading,
}) => {
  const {
    handleSubmit,
    control,
    formState: { isValid },
  } = useForm<CancelPremiumFormValues>({
    resolver: yupResolver(cancelPremiumFormSchema),
  })

  const onSubmit = (data: CancelPremiumFormValues): void => {
    onSave(data)
  }
  const selectedReason = useWatch({ control, name: 'reason' })
  const reasonDetailsShow =
    selectedReason ===
    CANCEL_PREMIUM_REASONS[CANCEL_PREMIUM_REASONS.length - 1].value
  return (
    <Form>
      <FormContainer>
        <Controller
          name='reason'
          control={control}
          render={({ field: { onChange, value, ref } }) => (
            <StyledRadioGroup ref={ref} value={value} onChange={onChange}>
              {CANCEL_PREMIUM_REASONS.map((reason) => (
                <StyledRadio key={reason.value} value={reason.value}>
                  {reason.value}
                </StyledRadio>
              ))}
            </StyledRadioGroup>
          )}
        />
        {reasonDetailsShow && (
          <Controller
            name='reasonDetails'
            control={control}
            render={({ field: { onChange, value } }) => (
              <PrimaryTextArea
                maxLength={MAX_COMMENT_LENGTH}
                autoSize={{ minRows: 4 }}
                showCount={{
                  formatter: (count) =>
                    count.value ? `${count.count}/${MAX_COMMENT_LENGTH}` : '',
                }}
                style={{ resize: 'none' }}
                rows={4}
                placeholder='Specify the reason for canceling your subscription'
                value={value}
                onChange={onChange}
              />
            )}
          />
        )}
      </FormContainer>
      <CancelButtons
        loading={loading}
        onCancel={handleSubmit(onSubmit)}
        disabled={!isValid}
      />
    </Form>
  )
}
